import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const TwoBarsIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <rect fill="rgb(253.5, 243, 232.5)" height="12" transform="matrix(-1 0 0 1 13.5 2)" width="2" />
    <rect fill="currentColor" height="8" transform="matrix(-1 0 0 1 9 6)" width="2" />
    <rect fill="currentColor" height="4" transform="matrix(-1 0 0 1 4.5 10)" width="2" />
  </svg>
);
